
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth,apikey } from '../../constants/api';
import {
    TRANSACTION_FETCH,
    TRANSACTION_SUMMARY_FETCH,
    TRANSACTION_MONTHLY_FETCH
} from '../actions';

import {
    transactionSuccess,
    transactionFail,
    transactionSummarySuccess,
    transactionSummaryFail,
    transactionMonthlySuccess,
    transactionMonthlyFail
} from './actions';
import { sortOrder} from '../../helpers/Utils';

const transactionFetchAsync = async (user, queryString) =>
    await API.get('/transaction?'+queryString,
    {
      headers : {
        'Content-Type': 'application/json',
        'userid': user.user_id,
        'usertoken': user.user_token,
        'apikey': apikey
      }
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionFetch({ payload }) {
    const queryString = Object.keys(payload.transaction).map(key => key + '=' + payload.transaction[key]).join('&');
    console.log("queryString : ",queryString)
    try {
        const transactionFetch = yield call(transactionFetchAsync,'', queryString);
        console.log("transactionFetch -> ",transactionFetch)
        if (transactionFetch.data.StatusCode === "0000") {
          const transactionFetchs = transactionFetch.data.ResultValues

            const total = transactionFetchs.map(item => item.tran_amount).reduce((prev, next) => prev + next)
            let transactionData = {}
            transactionData.transaction = transactionFetch.data.ResultValues.sort(sortOrder('tran_issuedate','desc'))
            transactionData.total = total
            yield put(transactionSuccess(transactionData));

        } else {
            yield put(transactionFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionFail(error));
    }
}

//------------------------------------------------------------------------------
const transactionSummaryFetchAsync = async () =>
    await API.get('/transaction/getsummary',    {
      headers : {
        'Content-Type': 'application/json',
      //   'userid': user.user_id,
      //   'usertoken': user.user_token,
        'apikey': apikey
      }
    })
        .then(payments => payments)
        .catch(error => error);

function* transactionSummaryFetch({ payload }) {
    try {
        const transactionSummaryFetch = yield call(transactionSummaryFetchAsync);
        if (transactionSummaryFetch.data.StatusCode === "0000") {
            yield put(transactionSummarySuccess(transactionSummaryFetch.data.ResultValues));
        } else {
            yield put(transactionSummaryFail(transactionSummaryFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionSummaryFail(error));
    }
}
//------------------------------------------------------------------------------
// const transactionMonthlyFetchhAsync = async (queryString) =>
//     await API.get('/transaction/?'+queryString, {},
//     {
//       "headers" : auth
//     })
//         .then(payments => payments)
//         .catch(error => error);

function* transactionMonthlyFetch({ payload }) {
    const queryString = Object.keys(payload.monthly).map(key => key + '=' + payload.monthly[key]).join('&');
    try {
        const transactionFetch = yield call(transactionFetchAsync, queryString);
        if (transactionFetch.data.StatusCode === "0000") {
          const transactionFetchs = transactionFetch.data.ResultValues

          let object = {}, transactions = [];
          let period = [], amount = [];

          for (let i=0; i < transactionFetchs.length; i++) {
              let date = transactionFetchs[i].tran_issuedate;
              let localDateString = date.substring(0, 7)
              if (object[localDateString]) {
                  object[localDateString].tran_amount += transactionFetchs[i].tran_amount;
              } else {
                  transactionFetchs[i].date = localDateString;
                  delete transactionFetchs[i].tran_issuedate;
                  object[localDateString] = transactionFetchs[i];
              }
          }

          for (var prop in object) {
            transactions.push(object[prop]);
          }

          transactions.sort(sortOrder('date'));
          // transactions.splice(0, 3)

          for (let i=0; i<transactions.length; i++) {
            period.push(transactions[i].date)
            amount.push(transactions[i].tran_amount.toFixed(2))
          }

          let transactionChartMonthly = {}
          transactionChartMonthly.period = period
          transactionChartMonthly.amount = amount

          yield put(transactionMonthlySuccess(transactionChartMonthly));

        } else {
            yield put(transactionMonthlyFail(transactionFetch.data.Message));
        }
    } catch (error) {
        yield put(transactionMonthlyFail(error));
    }
}

//------------------------------------------------------------------------------
export function* watchTransactionFetch() {
    yield takeEvery(TRANSACTION_FETCH, transactionFetch);
    yield takeEvery(TRANSACTION_SUMMARY_FETCH, transactionSummaryFetch);
    yield takeEvery(TRANSACTION_MONTHLY_FETCH, transactionMonthlyFetch);
}

export default function* rootSaga() {
    yield all([
        fork(watchTransactionFetch),
    ]);
}
